<template>
  <div>
    <FormButton
      :disabled="!$route.params.enableBack"
      class="mr-2"
      @click="$router.go(-1)"
    >
      &lt; BACK
    </FormButton>
    <FormButton @click="$router.push('/')">
      X CLOSE
    </FormButton>
  </div>
</template>

<script>
import FormButton from '@/components/Form/FormButton'

export default {
  name: 'SectionLayoutFooter',

  components: { FormButton },
}
</script>

<style scoped></style>
